module.exports = __webpack_public_path__ + "img/1edb5b9.jpg";